import * as types from "./types";

export const fetchingAppNotifications = () => ({
  type: types.FETCHING_APP_NOTIFICATIONS,
  loading: true
});

export const fetchedAppNotifications = (notifications, has_more, last_evaluated_key) => ({
  type: types.FETCHED_APP_NOTIFICATIONS,
  notifications: notifications,
  has_more: has_more,
  last_evaluated_key: last_evaluated_key,
  loading: false
});

export const errorFetchingAppNotifications = error => ({
  type: types.ERROR_FETCHING_APP_NOTIFICATIONS,
  error: error,
  loading: false
});

export const deletingAppNotification = () => ({
  type: types.DELETING_APP_NOTIFICATION,
  loading: true
});

export const deletedAppNotification = (u_guid, c_at) => ({
  type: types.DELETED_APP_NOTIFICATION,
  u_guid: u_guid,
  c_at: c_at,
  loading: false
});

export const errorDeletingAppNotification = error => ({
  type: types.ERROR_DELETING_APP_NOTIFICATION,
  error: error,
  loading: false
});
